import { call, put, delay, takeLatest } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import actions, { Types } from '~/store/ducks/antifraud';
import snackbar from '../ducks/snackbar';
import api from '~/services/api';

function* loadAntifraud({ partner, params }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/antifraud-rules`,
      { params }
    );

    yield put(actions.loadAntifraudSuccess(data));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* getAntifraud({ partner, id }) {
  try {
    const { data } = yield call(
      api.get,
      `/v1/partners/${partner}/antifraud-rules/${id}`
    );
    yield put(actions.loadAntifraudSuccess(data ? data.rule : {}));
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* addAntifraud({ partner, data }) {
  try {
    const res = yield call(
      api.post,
      `/v1/partners/${partner}/antifraud-rules`,
      data
    );

    yield put(actions.addAntifraudSuccess(res.data));

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'antifraud.add.success'
      })
    );

    yield put(push('/antifraud'));

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* updateAntifraud({ partner, id, data }) {
  try {
    const res = yield call(
      api.put,
      `/v1/partners/${partner}/antifraud-rules/${id}`,
      data
    );

    yield put(actions.loadAntifraudSuccess(res.data ? res.data.rule : {}));

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'antifraud.update.success'
      })
    );

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

function* removeAntifraud({ partner, id }) {
  try {
    yield call(api.delete, `/v1/partners/${partner}/antifraud-rules/${id}`);

    yield put(
      snackbar.showSnackbar({
        color: 'success',
        icon: 'check',
        text: 'antifraud.remove.success'
      })
    );

    yield put(push('/antifraud'));

    yield delay(5000);
    yield put(snackbar.hideSnackbar());
  } catch (e) {
    console.error('ERROR: ', e);
  }
}

const sagas = [
  takeLatest(Types.LOAD_ANTIFRAUD, loadAntifraud),
  takeLatest(Types.GET_ANTIFRAUD, getAntifraud),
  takeLatest(Types.ADD_ANTIFRAUD, addAntifraud),
  takeLatest(Types.UPDATE_ANTIFRAUD, updateAntifraud),
  takeLatest(Types.REMOVE_ANTIFRAUD, removeAntifraud)
];

export default sagas;
